import { Auth } from 'aws-amplify';
import { z } from 'zod';

import { createApi } from '../core';

const CreateTicketResponse = z.object({
  code: z.string(),
  expiresIn: z.number().optional(),
});
export type CreateTicketResponse = z.infer<typeof CreateTicketResponse>;

const ExchangeCodeResponse = z.object({
  idToken: z.string(),
  accessToken: z.string(),
  refreshToken: z.string(),
  username: z.string().optional(),
});
export type ExchangeCodeResponse = z.infer<typeof ExchangeCodeResponse>;

const ExchangeCodeParams = z.object({
  code: z.string().min(1),
});
export type ExchangeCodeParams = z.infer<typeof ExchangeCodeParams>;

export const ssoApi = createApi.group(['sso'], (createKey) => {
  return {
    createTicket: createApi.mutation({
      mutationKey: createKey(['createTicket']),
      mutationFn: async () => {
        const session = await Auth.currentSession();
        const idToken = session.getIdToken().getJwtToken();
        const accessToken = session.getAccessToken().getJwtToken();
        const refreshToken = session.getRefreshToken().getToken();

        return createApi.fetch({
          path: ['sso', 'ticket'],
          method: 'POST',
          body: {
            idToken,
            accessToken,
            refreshToken,
            targetApp: 'student-hub',
          },
          validator: CreateTicketResponse,
          basePath: 'studentHubAPI',
          sign: true,
        });
      },
    }),
    exchangeCode: createApi.mutation({
      mutationKey: createKey(['exchangeCode']),
      mutationFn: (params: ExchangeCodeParams) => {
        return createApi.fetch({
          path: ['sso', 'exchange'],
          method: 'POST',
          body: {
            code: params.code,
          },
          validator: ExchangeCodeResponse,
          basePath: 'studentHubAPI',
          sign: false,
        });
      },
    }),
  };
});
